import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	viewActiveIncidents: {
		id: 'issue-field-service-entity.common.active-incidents-indicator.view-active-incidents',
		defaultMessage: 'View open incidents',
		description: 'Button to open a popup to show the open incidents',
	},
});
